import * as Accordion from "@radix-ui/react-accordion";
import { Plus } from "lucide-react";
import { FAQ } from "../../content";
import { Eyebrow, Ph, Reveal } from "./Primitives";

const FAQ_LD = JSON.stringify({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: FAQ.filter((f) => f.a).map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});

export const Faq = () => (
  <section id="faq" data-testid="faq-section" className="bg-white py-24 sm:py-32">
    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: FAQ_LD }} />
    <div className="mx-auto grid max-w-[1400px] gap-14 px-5 sm:px-8 lg:grid-cols-12 lg:px-12">
      <Reveal className="lg:col-span-4">
        <Eyebrow>Häufige Fragen zum Schwimmkurs</Eyebrow>
        <h2 className="mt-6 text-4xl font-extrabold leading-[1.05] tracking-[-0.02em] text-navy sm:text-5xl">
          Gut zu <span className="font-light italic text-sky-700">wissen.</span>
        </h2>
        <p className="mt-6 text-base leading-relaxed text-slate-600 md:text-lg">Ihre Frage ist nicht dabei? Schreiben Sie uns – wir helfen gerne weiter.</p>
      </Reveal>
      <Reveal delay={0.1} className="lg:col-span-8">
        <Accordion.Root type="single" collapsible className="border-t border-navy/15">
          {FAQ.map((f, i) => (
            <Accordion.Item key={f.q} value={`q${i}`} className="border-b border-navy/15">
              <Accordion.Header>
                <Accordion.Trigger
                  data-testid={`faq-trigger-${i + 1}`}
                  className="faq-trigger group flex w-full items-center justify-between gap-6 py-6 text-left text-lg font-bold text-navy transition-colors hover:text-sky-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sky-500 sm:text-xl"
                >
                  <span className="flex items-baseline gap-5">
                    <span className="text-xs font-bold text-slate-500">0{i + 1}</span>
                    {f.q}
                  </span>
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-navy/20 transition-[transform,background-color,color] duration-500 group-data-[state=open]:rotate-45 group-data-[state=open]:bg-navy group-data-[state=open]:text-white">
                    <Plus className="h-4 w-4" />
                  </span>
                </Accordion.Trigger>
              </Accordion.Header>
              <Accordion.Content data-testid={`faq-content-${i + 1}`} className="overflow-hidden data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down">
                <div className="pb-7 pl-10 pr-14 text-base leading-relaxed text-slate-600">{f.a ?? <Ph>Antwort aus bestehenden Informationen ergänzen</Ph>}</div>
              </Accordion.Content>
            </Accordion.Item>
          ))}
        </Accordion.Root>
      </Reveal>
    </div>
  </section>
);
